import {Injectable} from '@angular/core';


/**
 * Translations for importing customer.
 */
@Injectable()
export class ImportCustomerTranslationsService {
  public i18nSuccessImport: string = $localize`:@@alertService.success.importStarted:Import started successfully.`;
  public i18nErrorImport: string = $localize`:@@alertService.error.importError:An error occured with customer importing!`;
  public i18nErrorImportFileType: string = $localize`:@@alertService.error.importFileType:Only .csv (comma seperated values) files are allowed!`;
  public i18nErrorWrongHeaders: string = $localize`:@@alertService.error.wrongHeaders:The headers in the provided file are wrong!`;

  constructor() { }
}
